import { acquireAuthSession } from '../helpers/AccessToken';

const fetchWithAuth = async (url, options = {}) => {
  const checkAborted = () => {
    if (options.signal?.aborted) {
      throw options.signal.reason || new DOMException('La petición se ha cancelado.', 'AbortError');
    }
  };
  checkAborted();
  const session = await acquireAuthSession();
  const accessToken = session?.access_token;
  if (!accessToken) {
    throw new Error('La sesión ha expirado. Inicia sesión de nuevo.');
  }

  const request = (token) => {
    const headers = new Headers(options.headers);
    headers.set('Authorization', `Bearer ${token}`);
    return fetch(url, { ...options, headers });
  };
  const response = await request(accessToken);
  if (response.status !== 401 || !['GET', 'HEAD'].includes((options.method || 'GET').toUpperCase())) {
    return response;
  }
  // Only retry authentication rejected before the API handler ran, not permission denials.
  const failure = await response.clone().json().catch(() => null);
  if (!['token_expired', 'token_invalid', 'no_token'].includes(failure?.code)) return response;
  checkAborted();
  const renewedSession = await acquireAuthSession({ rejectedToken: accessToken, expectedUserId: session.user.id });
  if (!renewedSession?.access_token) throw new Error('La sesión ha expirado. Inicia sesión de nuevo.');
  return request(renewedSession.access_token);
};

export default fetchWithAuth;
